module.exports = __webpack_public_path__ + "static/media/icPlayerLifetime.19c823cd.svg";